import { FiltersState } from "@app/store/storeTypes";

export function optimizeFiltersFn(state: FiltersState) {
    if (state.priceFrom && state.priceTo) {
        if (state.priceFrom > state.priceTo) {
            [state.priceFrom, state.priceTo] = [state.priceTo, state.priceFrom];
        }
    }

    if (state.yearFrom && state.yearTo) {
        if (state.yearFrom > state.yearTo) {
            [state.yearFrom, state.yearTo] = [state.yearTo, state.yearFrom];
        }
    }

    if (state.mileageFrom && state.mileageTo) {
        if (state.mileageFrom > state.mileageTo) {
            [state.mileageFrom, state.mileageTo] = [state.mileageTo, state.mileageFrom];
        }
    }

    if (state.horsePowerFrom && state.horsePowerTo) {
        if (state.horsePowerFrom > state.horsePowerTo) {
            [state.horsePowerFrom, state.horsePowerTo] = [state.horsePowerTo, state.horsePowerFrom];
        }
    }

    if (state.ownersQntFrom && state.ownersQntTo) {
        if (state.ownersQntFrom > state.ownersQntTo) {
            [state.ownersQntFrom, state.ownersQntTo] = [state.ownersQntTo, state.ownersQntFrom];
        }
    }

    if (state.engineVolumeFrom && state.engineVolumeTo) {
        if (state.engineVolumeFrom > state.engineVolumeTo) {
            [state.engineVolumeFrom, state.engineVolumeTo] = [
                state.engineVolumeTo,
                state.engineVolumeFrom
            ];
        }
    }
}